import React, { Component } from 'react';
import { Redirect } from "react-router-dom";
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button, Input } from 'react-materialize';
import * as actions from '../redux/actions/';
import { connect } from 'react-redux';

import Logger from '../functions/logging';

import login from '../api/login';

import * as auth from '../functions/auth';

import whiteLogo from '../assets/landing/pilotly-logo-white.png';

import PageLoader from '../components/global/PageLoader';

import localeMessages from '../locales/login';

import '../static/pilotly.css';
import '../static/Login.css';

/* Google analytics */
import SessionStatus from '../analytics/analytics-events/SessionStatus';
import { SessionStatusEvent } from '../analytics/analytics-events/constants';
import { isTesterFromUrl } from '../functions/helpers';

class Login extends Component {
	constructor(props) {
		super(props);

		this.state = {
			fields: { email: auth.getLogin() ? auth.getLogin() : "", password: "" },
			checked: true,
			loading: false,
			redirectToReferrer: false,
			errors: {}
		};

		this.validate     = this.validate.bind(this);
		this.submit       = this.submit.bind(this);
		this.handleChange = this.handleChange.bind(this);
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		Logger.log("Login", "getDerivedStateFromProps()", nextProps, prevState);
		return null;
	}

	handleChange(event) {
		let key = event.target.name;
		let value = event.target.value;

		let fields = { ...this.state.fields };
		fields[key] = value;

		Logger.log(this.constructor.name, "handleChange()", key, value);

		this.setState({ fields: fields });
	}

	handleCheckbox(event) {
		this.setState({ checked: !this.state.checked });
	}

	validate() {
		let fields = { ...this.state.fields };
		let errors = {};

		if (!fields.email) {
			errors['email'] = this.props.intl.formatMessage(localeMessages.login_error_email_missing);
		} else if (!auth.isValidEmail(fields.email)) {
			errors['email'] = this.props.intl.formatMessage(localeMessages.login_error_email_invalid);
		}

		if (!fields.password) {
			errors['password'] = this.props.intl.formatMessage(localeMessages.login_error_password_missing);
		}
		return Object.keys(errors).length ? errors : false;
	}

	hasErrors() {
		return Object.keys(this.state.errors).length ? true : false;
	}

	submit(event) {
		event.preventDefault();

		let fields = { ...this.state.fields };

		let errors = this.validate(fields);
		if (errors) {
			this.setState({ errors: errors });
			return;
		}

		this.setState({ loading: true, errors: {} }, () => {
			this.loginUser(fields);
		});
	}

	async loginUser(fields) {
		Logger.log(this.constructor.name, "loginUser()", (fields ? fields.email : null));
		/* Google analytics event */
		let sessionStatus = new SessionStatus(SessionStatusEvent.AUTH_BASIC_LOGIN, '', '', false, false, true);
		sessionStatus.gaTracker = this.props.tracker;
		sessionStatus.state = 'start';
		this.props.globalAnalyticsAdapter.reportAnalyticsEvent(sessionStatus);

		try {
			const result = await login(fields.email, fields.password);

			if (result) {
				Logger.log(this.constructor.name, "Login Successful", result);
				auth.setLogin(fields.email);
				auth.setToken(result);
				this.forceUpdate(() => {
					Logger.log(this.constructor.name, "loginUser() updated");
				});
				this.setState(() => ({
					redirectToReferrer: true
				}));

				/* Google analytics event */
				let sessionStatus = new SessionStatus(SessionStatus.AUTH_BASIC_LOGIN, '', '', false, false, true);
				sessionStatus.gaTracker = this.props.tracker;
				sessionStatus.state = 'finish';
				this.props.globalAnalyticsAdapter.reportAnalyticsEvent(sessionStatus);

			} else {
				this.setState({ loading: false });
				Logger.log(this.constructor.name, "Login Failed: No result token???");
				let errors = { ...this.state.errors };
				errors["reason"] = this.props.intl.formatMessage(localeMessages.login_error_failed);
				this.setState({ errors });

				/* Google analytics event */
				let sessionStatus = new SessionStatus(SessionStatus.AUTH_BASIC_LOGIN, '', '', false, false, true);
				sessionStatus.gaTracker = this.props.tracker;
				sessionStatus.state = 'fail';
				this.props.globalAnalyticsAdapter.reportAnalyticsEvent(sessionStatus);
			}
		}
		catch (error) {
			this.setState({ loading: false });
			let errors = { ...this.state.errors };
			Logger.log(this.constructor.name, "Login Failed", error);

			errors["reason"] = this.props.intl.formatMessage(localeMessages.login_error_incorrect);

			if (error.code) {
				Logger.log(this.constructor.name, "Login Failed error.code", error.code);
				if (error.code.reason === "account_locked") {
					Logger.log(this.constructor.name, "Login Failed error.code account_locked", error.code);
					errors["reason"] = this.props.intl.formatMessage(localeMessages.login_error_lockedout, { lockoutPeriod: error.code.lockout_period });
				}
				else if (error.code.reason === "incorrect_email_or_password" && error.code.failed_attempts) {
					Logger.log(this.constructor.name, "Login Failed error.code incorrect_email_or_password", error.code);
					const failed_attempts = parseInt(error.code.failed_attempts);
					if (failed_attempts > 2) {
						Logger.log(this.constructor.name, "Login Failed error.code failed_attempts", error.code.failed_attempts);
						errors["reason"] = this.props.intl.formatMessage(localeMessages.login_error_lockout_warning);
					}
				}
			}
			Logger.log(this.constructor.name, "Login Failed errors[reason]", errors["reason"]);

			this.setState({ errors });
		}
	}

	useFacebook() {
		Logger.log(this.constructor.name, "useFacebook()", this.props, this.state);
	}

	render() {
		Logger.log(this.constructor.name, "render()", this.props, this.state);

		const { from } = this.props.location.state || (auth.isAuthenticated() === true ? { from: { pathname: '/home' } } : false) || { from: { pathname: '/' } };
		const { redirectToReferrer } = this.state;
		const { targetParams } = this.props;
		const url = targetParams && targetParams.url;
		if (!isTesterFromUrl(url) ) {
			return <Redirect to="/non-partner-restricted" />;
		}

		if (redirectToReferrer === true) {
			Logger.log(this.constructor.name, "redirectToReferrer", from);
			this.props.history.push(from.pathname);
			return null;
		}

		const errorMsg = this.state.errors.reason ? this.state.errors.reason : null;

		return (
			<div className="pilotly-login">
				<PageLoader addedClass="pilotly-blue-background" loading={this.state.loading} small={true} />

				<div className="pilotly-login-header">
					<a href="/"><img className="pilotly-login-header-logo" src={whiteLogo} alt="pilotly"/></a>
				</div>
				<div className="pilotly-login-container">
					<div className="pilotly-login-content">
						<h1 className="pilotly-login-title">
							<FormattedMessage
								id="login.title"
								defaultMessage={"Log In"}
							/>
						</h1>
						<form className="pilotly-login-form pilotly-login-inner" onSubmit={this.submit}>
							{/* <div className="buttonView--center">
								<div tabIndex="0" className="buttonView buttonView--primary buttonView--large google-auth-button" onClick={() => this.useFacebook()}>
									<span>
										<FormattedMessage
											id="login.button.facebook"
											defaultMessage={"Use Facebook Account"}
										/>
									</span>
								</div>
							</div> */}

							{/* <div className="pilotly-login-seperator">
								<FormattedMessage
									id="login.separator.or"
									defaultMessage={"or"}
								/>
							</div> */}

							<div className={"pilotly-login-alert pilotly-login-alert-error" + (this.hasErrors() ? "" : " display-none")}>
								<p>
									<strong>
										{errorMsg ? 
											errorMsg
											:
											<FormattedMessage
												id="login.alert.failed"
												defaultMessage={"The username or password is not correct."}
											/>
										}
									</strong>
								</p>
								<p>
									<a href="/forgot-password">
										<FormattedMessage
											id="login.password.forgot"
											defaultMessage={"Forget your password?"}
										/>
									</a>
								</p>
							</div>

							<div className={"" + (this.state.errors.email ? " errors-border" : "")}>
								<Input name="email"
									type="email"
									label={this.props.intl.formatMessage(localeMessages.email)}
									value={this.state.fields.email}
									onChange={(e) => this.handleChange(e)}>
								</Input>
								{/* <p className="error-text" style={{ display: this.state.errors.email ? "block" : "none" }}>
									{this.state.errors.email ? this.state.errors.email : ""}
								</p> */}
							</div>

							<span className="field-no-status"></span>

							<div className="">
								<Input name="password"
									type="password"
									label={this.props.intl.formatMessage(localeMessages.password)}
									value={this.state.fields.password}
									onChange={(e) => this.handleChange(e)}>
								</Input>
								{/* <p className="error-text" style={{ display: this.state.errors.password ? "block" : "none" }}>
									{this.state.errors.password ? this.state.errors.password : ""}
								</p> */}

								<span className="pilotly-login-input-help">
									<a href="/forgot-password" tabIndex="-1">
										<FormattedMessage
											id="login.password.forgot"
											defaultMessage={"Forget your password?"}
										/>
									</a>
								</span>
							</div>

							<div className="form-input form-input--button">
								<Button tabIndex="3" className="buttonViewX buttonView--defaultX buttonView--primaryX buttonView--largeX button-submitX"
									onClick={this.submit}>
									<FormattedMessage
										id="login.button.login"
										defaultMessage={"Log In"}
									/>
								</Button>
							</div>
						</form>
					</div>
					<div className="pilotly-login-footer">
						<div className="pilotly-login-footer-top">
							<span>
								<FormattedMessage
									id="login.register.prompt"
									defaultMessage={"Don’t have an account?"}
								/>
							</span>
							<a className="buttonView buttonView--default buttonView--background" href="/register">
								<FormattedMessage
									id="login.button.register"
									defaultMessage={"Sign Up"}
								/>
							</a>
						</div>
						<div className="pilotly-login-footer-bottom">
							<div className="pilotly-login-nav">
								<a href="https://twitter.com/PilotlyInsights" target="_blank" rel='noopener noreferrer'>
									<span>
										<FormattedMessage
											id="login.link.twitter"
											defaultMessage={"Twitter"}
										/>
									</span>
								</a> 
								<a href="/contact-us" rel='noopener noreferrer'>
									<span>
										<FormattedMessage
											id="login.link.help"
											defaultMessage={"Help"}
										/>
									</span>
								</a> 
								<a href="/terms-and-conditions" rel='noopener noreferrer'>
									<span>
										<FormattedMessage
											id="login.link.terms"
											defaultMessage={"Terms"}
										/>
									</span>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	tracker: state.GlobalAnalyticsAdapterReducer.gaTracker,
	targetParams: state.targetProcess.targetParams,
	globalAnalyticsAdapter: state.GlobalAnalyticsAdapterReducer.globalAnalyticsAdapter,	
});

export default connect(mapStateToProps, actions)(injectIntl(Login));



// WEBPACK FOOTER //
// ./src/pages/Login.js